import { createContext } from 'react';

// Create auth context
export const AuthContext = createContext();